import { Component, Input, inject } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { InfoGroupComponent, ItemComponent, ListDetailComponent } from '@tecalisdev/infinity';

import { IFormFieldPreset, IFormFieldPresetFieldDef } from '../form-field-presets';

@Component({
	selector: 'app-form-step-composite-fields-preview',
	imports: [ReactiveFormsModule, TranslatePipe, ItemComponent, ListDetailComponent, InfoGroupComponent],
	templateUrl: './form-step-composite-fields-preview.component.html',
	styleUrl: './form-step-composite-fields-preview.component.scss',
})
export class FormStepCompositeFieldsPreviewComponent {
	@Input({ required: true }) preset!: IFormFieldPreset;
	@Input() fieldsArray?: FormArray;
	@Input() selectedLocaleId = 'es';

	private trans = inject(TranslateService);

	public get hasCompositeGrid(): boolean {
		return Boolean(this.preset.presetFields?.some((field) => field.gridSpan));
	}

	public resolveFieldTitle(fieldDef: IFormFieldPresetFieldDef, index: number): string {
		const fieldGroup = this.fieldsArray?.at(index) as FormGroup | undefined;
		const localizedTitle = String(fieldGroup?.get('title')?.get(this.selectedLocaleId)?.value ?? '').trim();

		if (localizedTitle) {
			return localizedTitle;
		}

		return this.trans.instant(fieldDef.titleKey);
	}
}
